var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-add"},[(!_vm.$store.state.main.isMobile)?_c('AddCard',{staticClass:"card-add__pc"}):_c('AddCardMobile',{staticClass:"card-add__mobile"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }